<template>
  <div class="excelExport-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.phone"
                 clearable
                 placeholder="输入手机号查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入编号查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:150px"
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>&nbsp;
          <Button @click="showModel()"
                  type="success">生成并下载二维码</Button>&nbsp;
          <!-- <Button @click="downLoad()"
                  type="success">筛选并下载二维码</Button> -->
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="生成二维码"
           @on-ok="createBrand()"
           :loading="qrcodeloading">
      <Form :model="brand"
            ref="brandValidate"
            action="javascript:void(0)">
        <FormItem label="生成数量( 最多生成50个 )">
          <Input v-model="brand.nums"
                 placeholder="输入数量..."></Input>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>
  
  <script>
export default {
  name: 'excelExport-list',
  data () {
    return {
      qrcodeloading: true,
      dataloading: true,
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      brand: {
        nums: '',
      },
      title: '',
      formItem: {
        'key': '',
        'phone': ""
      },
      statusList: [
        { id: 1, name: "未使用" },
        { id: 2, name: "已使用" }
      ],
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '编号',
          key: 'qrcode_num',
          width: 150,
        },
        {
          title: '绑定用户',
          key: 'username',
          width: 150,
        },
        {
          title: '备注',
          key: 'mark',
          width: 150,
        },
        {
          title: '角色',
          key: 'type',
          width: 200,
          render: (h, params) => {
            return h(
              "div",
              params.row.type == "1"
                ? "商户"
                : (params.row.type == "2" ? "分销商" : "")
            );
          }
        },
        {
          title: '使用状态',
          key: 'status',
          width: 200,
          render: (h, params) => {
            return h(
              "div",
              params.row.status == "1"
                ? "未使用"
                : "已使用"
            );
          }
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 80,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         style: {
        //           marginRight: '8px',
        //         },
        //         props: {
        //           type: 'success',
        //           size: 'small',
        //         },
        //         on: {
        //           click: () => {
        //             window.location.href = this.$publicData.ossUrl + params.row.qrcode_url;
        //           }
        //         }
        //       }, '下载')
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
      excelExport: {
        name: '',
        status: true,
      },
      showModalStatus: false,
    }
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.qrcodes.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        'key': this.formItem.key,
        "page": this.pages.page,
        "size": this.pages.size,
        'status': this.formItem.status,
        'phone': this.formItem.phone,

      };
      this.$api.qrcodes.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand (name) {
      this.qrcodeloading = true;
      this.$api.qrcodes.create(this.brand).then(res => {
        if (res.code == 200) {
          this.qrcodeloading = false;
          this.showModalStatus = !this.showModalStatus;
          this.brand.nums = '';
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
      this.$nextTick(() => { this.qrcodeloading = true; });
    },
    downLoad (name) {
      var ps = {
        'key': this.formItem.key,
        'status': this.formItem.status,
        'phone': this.formItem.phone,
      };
      this.$api.qrcodes.download(ps).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
  },
}
  </script>
  